var secret = {
    bindings : {
        url : '@',
        text : '@'
    },
    transclude : true,
    controller : function VelvetCtrl ($element) {
        
        var hoverElement, margin = 10, hoverAnim = new TimelineMax({paused:true});

        function link () {
            
            hoverElement = $element[0].querySelector('.secret-hover');

            $element[0].addEventListener('mouseenter', onMouseEnter);
            $element[0].addEventListener('mouseleave', onMouseLeave);

            // add touch events
            if (Modernizr.touchevents) {
                // console.log("add touch listeners")
                $element[0].addEventListener('touchend', onTouchEnd);
                window.addEventListener('scroll', onWindowScroll);
            }

            TweenMax.set(hoverElement, {y:25});

            hoverAnim.add(new TweenMax(hoverElement, .25, {y:0, opacity:1}))
        }

        function onMouseEnter (event) {
            // console.log("mouseenter");
            $element[0].classList.add('active');
            
            var minX = margin - event.target.offsetLeft;
            var maxX = window.innerWidth - hoverElement.offsetWidth - event.target.offsetLeft - margin;
            var desiredX = Math.max(minX, Math.min(event.clientX - event.target.offsetLeft - hoverElement.offsetWidth * 0.5, maxX));
            TweenMax.set(hoverElement, {x:desiredX});

            hoverAnim.play();
        }

        function onTouchEnd (event) {
            // console.log("touchstart");
            $element[0].classList.add('active');
            var minX = margin - event.target.offsetLeft;
            var maxX = window.innerWidth - hoverElement.offsetWidth - event.target.offsetLeft - margin;
            var desiredX = Math.max(minX, Math.min(0, maxX));
            TweenMax.set(hoverElement, {x:desiredX});
            hoverAnim.play();
        }

        function onMouseLeave (event) {
            // console.log("mouseleave");
            hoverAnim.reverse();
            $element[0].classList.remove('active');
        }

        function onWindowScroll (event) {
            // console.log("onWindowScroll");
            hoverAnim.reverse();
            $element[0].classList.remove('active');
        }

        this.$postLink = link;
        this.$onInit = function () {
            // console.log("what");
        };
    },
    template : '<span class="secret-trigger" ng-transclude>' +
    '</span>' +
    '<span class="secret-hover" ng-class="$ctrl.url?\'image\':\'text\'">' +
        '<img ng-src="{{$ctrl.url}}" ng-if="$ctrl.url" />' +
        '<p ng-bind="$ctrl.text" ng-if="$ctrl.text"></p>' +
    '</span>'
};